import { render } from "./RiskRating.vue?vue&type=template&id=c7ea3bc2"
import script from "./RiskRating.vue?vue&type=script&lang=js"
export * from "./RiskRating.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__